import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { Artist } from '@/types/database';

interface ArtistState {
  artist: Artist | null;
  loading: boolean;
  error: string | null;
}

export function useArtist(slug: string | undefined): ArtistState {
  const [state, setState] = useState<ArtistState>({
    artist: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    if (!slug) {
      setState({ artist: null, loading: false, error: null });
      return;
    }
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));

    void supabase
      .from('artists')
      .select('*')
      .eq('slug', slug)
      .maybeSingle()
      .then(({ data, error }) => {
        if (!alive) return;
        if (error) {
          setState({ artist: null, loading: false, error: error.message });
          return;
        }
        setState({ artist: data, loading: false, error: null });
      });

    return () => {
      alive = false;
    };
  }, [slug]);

  return state;
}
